import { render, staticRenderFns } from "./PatientAdministrativeForm.vue?vue&type=template&id=2c8b0244"
import script from "./PatientAdministrativeForm.vue?vue&type=script&lang=js"
export * from "./PatientAdministrativeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports